require('./known-state.scss');

const KnownStateComponent = {
    selector: 'sbKnownState',
    template: require('./known-state.html'),
    bindings: {
        thing: '<',
    },
};

export default KnownStateComponent;



// WEBPACK FOOTER //
// ./src/app/detail/known-state-component/index.js